import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";

/**
 * Props for `TextColumns`.
 */
export type TextColumnsProps = SliceComponentProps<Content.TextColumnsSlice>;

/**
 * Component for "TextColumns" Slices.
 */
const TextColumns: FC<TextColumnsProps> = ({ slice }) => {

  const colSettings = Number(slice.primary.column_setting)
  const contact = slice.primary.contact_us_contacts ? "contact" : null
  const paddingState = slice.primary.no_padding ? "no-padding" : null
  const theme = slice.primary.background === "Orange" ? "bg-orange text-white prose-a:text-white prose-a:underline mb-16" : slice.primary.background === "Grey" ? "bg-lightergrey text-jade prose-a:text-blue-500 prose-a:underline mb-16" : "prose-a:text-blue-500 prose-a:no-underline";

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`font-fellix text-[18px] leading-[26px] px-4 md:px-8 lg:px-12 ${theme}`}
    >
      <div className={` ${contact} max-w-[1280px] mx-auto`}>
        <div className={slice.primary.lines_at_top === true ? "inner-wrapper lines-at-top "+paddingState : "inner-wrapper "+paddingState}>
        {slice.primary.title ?
          <article className="text-[28px] leading-[36px] text-center font-semibold py-16">
            <PrismicRichText field={slice.primary.title}/>
          </article>
        : null }
          <div>
            {colSettings === 5 ? 
              <ul className="w-full">
              {slice.primary.columns?.map((item: any, index: number)=>{
                return (
                    <li className={`inline-block max-w-[100%] md:max-w-[50%] lg:max-w-[20%] px-4 pb-12 align-top prose prose-h2:!text-[80px] prose-h2:!leading-[60px] prose-h2:text-orange prose-h2:!font-normal prose-h2:mb-[20px]
prose-h4:font-semibold prose-h4:text-[24px] prose-h4:leading-[28px] prose-h4:text-left prose-h4:mt-0 prose-h4:mb-[12px] prose-a:text-blue-500 
prose-p:text-[14px] prose-p:leading-[22px] prose-p:font-normal`} key={index}>
                      <PrismicRichText field={item.column_content} />
                    </li>
                )})}
              </ul> :
              <div className="md:flex justify-between md:gap-12">
                  {slice.primary.columns?.map((item: any, index: number)=>{
                return (
                    <div className={`${theme} w-full mb-12 prose prose-strong:font-semibold prose-strong:text-[18px] prose-p:m-0 prose-p:p-0 prose-p:text-[18px] prose-p:leading-[26px] prose-p:pb-4 prose-a:text-blue-500  prose-a:hover:underline`} key={index}>
                      <PrismicRichText field={item.column_content} />
                    </div>
                )})}
              </div>}
            </div>
        </div>
      </div>
    </section>
  )
}

export default TextColumns;

